import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v1/ThirdParty'

const thirdyParty = {
  QrCodeLogEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/QrCodeLog/QrCodeLogEdit`,
      data
    })
  },
  CheckBalance(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/WechatPayConfig/CheckBalance`,
      params
    })
  },
  WechatPayConfigList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/WechatPayConfig/List`,
      params
    })
  },
  WechatPayConfigEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/WechatPayConfig/Edit`,
      data
    })
  },
  SendEmailLogEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Email/SendEmailLogEdit`,
      data
    })
  },
  GetUnlimitedQRCode(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Wechat/MiniProgram/GetUnlimitedQRCode`,
      params
    })
  },
  OcrBusinessLicense(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Baidu/OcrBusinessLicense`,
      data
    })
  },
  OcrIdCard(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Baidu/OcrIdCard`,
      data
    })
  }

}

export default thirdyParty
